/* GENERATED BY tools/gen_web_effect_keywords.py - DO NOT EDIT.
 *
 * effect config id -> EffectKeyword, from the served database's own `effects[]`.
 *
 * A runtime object carries AppliedEffects[].ConfigId, never the keyword, so this is how the
 * client answers "is this creature taunting RIGHT NOW" - including when the taunt was
 * granted by another card, which is the case a printed-keyword read gets wrong.
 */
export const EFFECT_KEYWORD: Readonly<Record<string, string>> = Object.freeze({
  "Immune-to-poison-immediately": "ImmuneToKeyword",
  "attack-2-all-non-sagittarian": "DealDamage",
  "attack-2-target": "DealDamage",
  "attack-2-target-HA": "DealDamage",
  "attack-3-or-5-when-turn-5-target-HA": "ConditionEffect",
  "attack-all-1-HA": "Destroy",
  "attack-all-opponent-1-HA": "Destroy",
  "attack-aoe-2-all": "Destroy",
  "attack-aoe-permadeath": "Destroy",
  "attack-aoe-x-all": "DealDamageX",
  "attack-random-1-HA": "DealDamage",
  "attack-random-2": "DealDamage",
  "attack-spell-1": "DealDamage",
  "attack-x-depended-on-beasts-target": "GiveEffects",
  "barricade": "Barricade",
  "biff-self-player-hand-capacity-1": "HandCountBuff",
  "blacksmith": "GiveEffects",
  "blacksmith-immediately": "Blacksmith",
  "buf-1-attack-3-turn-immediately": "BuffReplaceAttack",
  "buf-1-attack-immediately": "BuffAttack",
  "buf-1-attack-replace-immediately": "BuffReplaceAttack",
  "buf-1-hp-immediately": "BuffHealth",
  "buf-1-hp-replace-immediately": "BuffReplaceHealth",
  "buf-1-peplace-hp-immediately": "BuffReplaceHealth",
  "buf-1-replace-attack-immediately": "BuffReplaceAttack",
  "buf-2-armor-immediately": "BuffArmor",
  "buf-2-attack-immediately": "BuffAttack",
  "buf-2-hp-immediately": "BuffHealth",
  "buf-3-armor-immediately": "BuffArmor",
  "buf-5-attack-immediately": "BuffAttack",
  "buf-5-hp-immediately": "BuffHealth",
  "buf-6-armor-immediately": "BuffArmor",
  "buf-9-armor-immediately": "BuffArmor",
  "buf-Sunfall-attack-1": "MyrmidonTrainerAttackAura",
  "buf-Sunfall-hp-1": "MyrmidonTrainerHpAura",
  "buf-decrease-1-attack-immediately": "BuffReplaceAttack",
  "buf-decrease-1-attack-permanent": "BuffReplaceAttack",
  "buf-decrease-2-attack-immediately": "BuffReplaceAttack",
  "buf-decrease-2-attack-permanent": "BuffReplaceAttack",
  "buf-self-attack-by-count-allied-graveyard": "BuffReplaceAttack",
  "buff-1-attack-when-heal": "BuffAttack",
  "buff-attack-foreach-hand-card": "ChironAttackAura",
  "buff-hero-next-played-beast-turn-to-taunt": "GiveEffects",
  "buff-hp-2-played-beasts": "KallistoAura",
  "buff-immortal-1-turn-immediately": "Immortal",
  "buff-immortal-immediately": "Immortal",
  "buff-immortal-one-hit-immediately": "ImmortalOneHit",
  "buff-mana-cost-by-each-servants-table": "TalosAura",
  "buff-mana-cost-hand-cards-kabaloi": "KobaloiRecruiterAura",
  "burn-hp-3-immediately": "DealDamage",
  "burn-hp-5-immediately": "DealDamage",
  "cmdr-aelio-startturn-damage": "DealDamage",
  "cmdr-alpha-wolf-attack-aura": "MyrmidonTrainerAttackAura",
  "cmdr-mudgrin-discard": "TomyiosDiscardGate",
  "cmdr-mudgrin-discard-payoff": "Discard",
  "cmdr-phearei-attack-debuff": "BuffReplaceAttackLimit",
  "cmdr-phearei-debuff-attacker": "PheareiDebuffAttackerGate",
  "cmdr-syna-attack-debuff": "BuffReplaceAttackLimit",
  "cmdr-syna-poisoned-attacker-debuff": "SynaPoisonedAttackerDebuff",
  "cmdr-trapjaw-draw": "Draw",
  "cmdr-trapjaw-heal": "Heal",
  "cmdr-trapjaw-soul-counter": "ThresholdCounter",
  "cmdr-venomtail-poison-death-heal": "VenomtailPoisonDeathHeal",
  "cmdr-wolfshadow-cost-increase": "BuffReplaceMana",
  "cmdr-wolfshadow-graveyard-return": "WolfshadowGraveyardReturn",
  "confuse-1": "Confusing",
  "cursed-buff": "GiveEffects",
  "damage-random-creature-1": "DealDamage",
  "deal-1-damage-opponent-hero": "DealDamage",
  "deal-damage-depended-on-beasts-opposite-side-immediately": "DealDamage",
  "debuf-1-health-immediately": "BuffReplaceHealth",
  "debuf-half-hp-immediately": "DeBuffHealth",
  "debuf-half-max-attack-immediately": "BuffReplaceAttack",
  "debuff-2-attack-immediately": "BuffReplaceAttack",
  "debuff-2-attack-immediately-damage-limit-1": "BuffReplaceAttackLimit",
  "debuff-2-health-immediately": "BuffReplaceHealth",
  "destroy-building-target": "DealDamage",
  "destroy-card-immediately": "DealDamage",
  "discard-1-hand-and-draw-2-immediately": "DiscardX",
  "discard-2-hand-random-before-dead": "Discard",
  "discard-deck-by-kabaloi-table-count": "DiscardDeck",
  "discard-x-cards-in-hand-immediately": "DiscardX",
  "discard-x-hand-immediately": "DiscardX",
  "discard-x-lose-hp-x-take-x-damage": "GiveEffects",
  "draw": "Draw",
  "draw-1-end-turn": "Draw",
  "draw-1-random-horned-lodge": "DrawAoe",
  "draw-1-random-ranger": "DrawAoe",
  "draw-2": "Draw",
  "draw-2-HA": "Draw",
  "draw-foreach-outrider-in-play": "Draw",
  "draw-when-cast-to-sunfall": "Draw",
  "draw-x-card": "DrawXCard",
  "empower": "GiveEffects",
  "extra-card-acolyte": "ExtraCard",
  "extracard-shadewarriors": "ExtraCard",
  "extracard-warchief": "ExtraCard",
  "eye-of-typhon": "GiveEffects",
  "fade-health-1": "DealDamage",
  "fast": "Fast",
  "fly": "GiveTemporaryEffectsOnce",
  "fortify-1": "GiveEffects",
  "fortify-1-all-hollows": "GiveEffects",
  "frenzy-1": "Striking",
  "give-Immune-to-poison": "ImmuneToPoisonAura",
  "give-Sunfall-hp": "GiveEffects",
  "give-all-creatures-lava-more-4-debuff-2-attack": "AttackAuraGain",
  "give-armor-after-discard-notus": "GiveEffects",
  "give-buff-armor-2-hero": "GiveEffects",
  "give-buff-armor-3-HA": "GiveEffects",
  "give-buff-armor-6-HA": "GiveEffects",
  "give-buff-armor-9-HA": "GiveEffects",
  "give-buff-attack-1-aoe": "GiveEffects",
  "give-buff-attack-1-self-when-allied-creature-enter-battlefield": "Pillager",
  "give-buff-attack-1-target": "GiveEffects",
  "give-buff-attack-2-aoe": "GiveEffects",
  "give-buff-attack-2-debuff-hp-1-target-HA": "GiveEffects",
  "give-buff-attack-2-target": "GiveEffects",
  "give-buff-attack-5-target": "GiveEffects",
  "give-buff-health-2-aoe-beasts-HA": "GiveEffects",
  "give-buff-hp-1-target": "GiveEffects",
  "give-buff-hp-2-aoe": "GiveEffects",
  "give-buff-hp-2-target": "GiveEffects",
  "give-buff-hp-5-target": "GiveEffects",
  "give-buffs-aspirant-by-higher-creature-enter-battlefield": "Aspirant",
  "give-bufs-while-Sunfall-in-play": "AchillesAura",
  "give-confuse-target-1-HA": "GiveEffects",
  "give-cruse-target-sacrifice-5-discard-2-hand-random": "GiveEffects",
  "give-debuff-attack-2-helath-2-non-heades": "GiveTemporaryEffects",
  "give-debuff-attack-hp-2-to-non-heades-from-self-hero": "GiveEffects",
  "give-debuff-cruse-half-max-attack": "GiveEffects",
  "give-debuff-hex-half-hp-target": "GiveEffects",
  "give-fly-immediately": "GiveEffects",
  "give-immortal-aoe-1-turn": "GiveEffects",
  "give-immortal-hero-1-turn": "GiveEffects",
  "give-immortal-hero-temporary": "ImmortalAura",
  "give-immortal-one-hit-immediately": "GiveEffects",
  "give-immortal-self-1-turn": "GiveEffects",
  "give-immortal-target-1-turn": "GiveEffects",
  "give-immune-while-Sunfall-in-play": "AchillesAura",
  "give-imunniting-to-sleeping-creature-with-3-or-less-lava": "ImmuneToSleepAura",
  "give-mark-debuff-1-damage": "GiveEffects",
  "give-parry-1-target": "GiveEffects",
  "give-reflect": "GiveEffects",
  "give-silence-1-target": "GiveEffects",
  "give-silence-all-creature": "GiveEffects",
  "give-silence-and-confuse-target-1": "GiveEffects",
  "give-silence-card-2-taget-HA": "GiveEffects",
  "give-silence-hero-HA": "GiveEffects",
  "give-sleep-all-1-HA": "GiveEffects",
  "give-sleep-all-creature": "GiveEffects",
  "give-stasis-1-turn-target": "GiveEffects",
  "give-stealth-and-ignore-taunt-every-turn": "GiveTemporaryEffectsOnce",
  "give-stealth-immediately": "GiveEffects",
  "give-stoneskin-target": "GiveEffects",
  "give-turn-owner-discard-2-hand-then-ressurect-2": "GiveTemporaryEffects",
  "give-xlava-summon-wildPigs": "GiveEffects",
  "heal-3-target-HA": "Heal",
  "heal-4-aoe": "Heal",
  "heal-hero-3": "Heal",
  "heal-hero-3-HA": "Heal",
  "heal-hero-5-HA": "Heal",
  "heal-max-adjacent": "Heal",
  "heal-max-aoe": "Heal",
  "heal-max-target": "Heal",
  "heal-target-3": "Heal",
  "hero-power-asclepius-restorative-touch": "AsclepiusHeroPower",
  "hero-power-atalanta-battle-harden": "AtalantaHeroPower",
  "hero-power-medea-veil-of-illusions": "MedeaHeroPower",
  "hero-power-sisyphus-unholy-pact": "SisyphusHeroPower",
  "if-played-horned-lodge-then-draw": "DrawIfPlayedCard",
  "if-played-ranger-then-draw": "DrawIfPlayedCard",
  "illusion-clarity-rally": "IllusionClarityRally",
  "illusion-dust-rally": "IllusionDustRally",
  "illusion-flame-rally": "DealDamage",
  "illusion-wind-rally": "IllusionWindRally",
  "immune-to-sleeping-immediately": "ImmuneToKeyword",
  "lifesteal": "LifeSteal",
  "mana-1": "ManaGain",
  "mana-1-overflow": "ManaGainOverflow",
  "mana-2": "ManaGain",
  "mana-3": "ManaGain",
  "mana-4": "ManaGain",
  "mark-1-addition-damage": "Mark",
  "next-beast-turn-taunt": "GiveEffects",
  "parry-1": "GiveEffects",
  "parry-2": "GiveEffects",
  "play-self-beast-deals-1-damage-opponent-hero": "GiveEffects",
  "poison-all-enemies": "GiveEffects",
  "poison-attack": "GiveEffects",
  "poison-enemies-1-HA": "GiveEffects",
  "poison-opponent-2-HA": "GiveEffects",
  "poisoning": "Poisoning",
  "poisoning-2": "Poisoning",
  "rage-1": "GiveEffects",
  "rally-adjacent-2-taunt": "GiveEffects",
  "raving": "Regen",
  "reborn": "Reborning",
  "recon-hero-draw-1": "Recon",
  "reflecting-immediately": "Reflect",
  "resurect-x-immediately": "ResurrectX",
  "resurrect-1-or-2-random-graveyard-if-more-5-HA": "ConditionEffect",
  "resurrect-1-random-graveyard": "Resurrect",
  "resurrect-2-random-graveyard": "Resurrect",
  "reveal-enemy-stealth-aoe": "Reveal",
  "reveal-sleeping-target": "Reveal",
  "reveal-stealth-immediately": "IllusionClarityRally",
  "reveal-taunt-immediately": "Reveal",
  "revenge-rangers-after-die": "Revenge",
  "revenge-rangers-after-play": "Revenge",
  "reverse-stunning-1": "Stunning",
  "runtime-Discard": "Discard",
  "runtime-GiveEffects": "GiveEffects",
  "sacrifice-1": "DealDamage",
  "sacrifice-10": "DealDamage",
  "sacrifice-5-before-dead": "DealDamage",
  "sanctification": "Sanctification",
  "set-hp-1-HA": "OverrideStat",
  "shuffle-deck": "SuffleDeck",
  "silence-card-immediately": "Silence",
  "slash": "Slash",
  "sleep-card-immediately": "Sleeping",
  "sleeping-indefinitely-immediately": "Sleeping",
  "stasis-1-turn": "Stasis",
  "stealthing": "Stealthing",
  "stoneskin": "GiveEffects",
  "strike-random-2": "Striking",
  "strike-target-1": "Striking",
  "stun-1": "GiveEffects",
  "stun-2-random-HA": "GiveEffects",
  "stun-random": "GiveEffects",
  "stun-target-HA": "GiveEffects",
  "stunning-1": "Stunning",
  "summon-1-jas-the-unliving": "Summon",
  "summon-1-or-2-jas-the-unliving-if-more-5-graveyad-HA": "ConditionEffect",
  "summon-1-or-2-ripAndRend-when-less-20-hp-HA": "ConditionEffect",
  "summon-1-ripAndRend": "Summon",
  "summon-1-sparoiPeltast": "Summon",
  "summon-2-Drakonewt": "Summon",
  "summon-2-grizzlyBears-HA": "Summon",
  "summon-2-jas-the-unliving": "Summon",
  "summon-2-or-3-grizzlyBears-when-less-25-hp-HA": "ConditionEffect",
  "summon-2-ripAndRend": "Summon",
  "summon-3-grizzlyBears-HA": "Summon",
  "summon-Blacksmith-HA": "Summon",
  "summon-avatar-thanatos": "Summon",
  "summon-bushwhackWolf-1": "Summon",
  "summon-cumberland-boar": "Summon",
  "summon-lavaGolem-immediately": "Summon",
  "summon-priestOfMomos": "Summon",
  "summon-spearOfAchiles": "Summon",
  "summon-spiderling-start-each-round": "Summon",
  "summon-stranglevines": "Summon",
  "summon-sunfire-strike": "Summon",
  "summon-wildPig": "Summon",
  "summon-wildPig-end-round": "Summon",
  "summon-wolf-pup-1-HA": "Summon",
  "swapStats-target-HA": "SwapStats",
  "synergy-attack-by-count-heal-table": "BuffReplaceAttack",
  "synergy-attack-by-count-rage-table": "BuffReplaceAttack",
  "synergy-attack-by-count-scorched-table": "BuffReplaceAttack",
  "synergy-attack-by-count-stun-table": "BuffReplaceAttack",
  "synergy-attack-by-count-summon-table": "BuffReplaceAttack",
  "synergy-attack-by-count-taunt-table": "BuffReplaceAttack",
  "synergy-attack-by-count-undead-table": "BuffReplaceAttack",
  "system-DeckDepleted": "DeckDepleted",
  "system-GenericAttack": "GenericAttack",
  "system-Mulligan": "Mulligan",
  "system-Silence": "Silence",
  "system-Sleeping": "Sleeping",
  "take-damage-ignore-taunting": "IgnoreTaunting",
  "take-x-self-dmage": "DealDamageX",
  "taunt": "Taunting",
  "try-give-discard-1-hand": "GiveEffects",
  "undead": "Undead",
  "vendetta": "GiveEffects",
  "warden-elder-treant-taunt-when-healed": "GiveEffects",
  "warden-emerald-elk-draw-if-hero-healed": "WardenEmeraldElk",
  "warden-forest-spirit-growth": "BuffAttack",
  "warden-hero-healed-this-turn": "WardenHeroHealedThisTurn",
  "warden-rooted-restoration": "WardenRootedRestoration",
  "warden-sage-renewal-cost-reduction": "BuffReplaceMana",
  "xlava-summon-wildPigs": "Overcharge",
});


/**
 * Effects the PLAYER must aim, and what they may aim at.
 *
 * A card carrying one of these does NOTHING unless `PlayCardCmd` is sent with a target -
 * the engine has an explicit `HasManualTargets` branch and skips them otherwise.
 */
export interface EffectAim {
  readonly types: readonly string[];
  readonly owner: string;
  readonly min: number;
}

export const EFFECT_AIM: Readonly<Record<string, EffectAim>> = Object.freeze({
  "attack-2-target": { types: ["Creature"], owner: "Opponent", min: 1 },
  "attack-2-target-HA": { types: ["Creature"], owner: "Opponent", min: 1 },
  "attack-3-or-5-when-turn-5-target-HA": { types: ["Creature"], owner: "Opponent", min: 1 },
  "attack-spell-1": { types: ["Creature"], owner: "Opponent", min: 1 },
  "attack-x-depended-on-beasts-target": { types: ["Creature", "Hero"], owner: "Opponent", min: 1 },
  "cursed-buff": { types: ["Creature"], owner: "Self", min: 1 },
  "destroy-building-target": { types: ["Building"], owner: "None", min: 1 },
  "eye-of-typhon": { types: ["Creature"], owner: "Opponent", min: 1 },
  "give-buff-attack-1-target": { types: ["Creature"], owner: "Self", min: 1 },
  "give-buff-attack-2-debuff-hp-1-target-HA": { types: ["Creature"], owner: "None", min: 1 },
  "give-buff-attack-2-target": { types: ["Creature"], owner: "Self", min: 1 },
  "give-buff-attack-5-target": { types: ["Creature"], owner: "Self", min: 1 },
  "give-buff-hp-1-target": { types: ["Creature"], owner: "Self", min: 1 },
  "give-buff-hp-2-target": { types: ["Creature"], owner: "Self", min: 1 },
  "give-buff-hp-5-target": { types: ["Creature"], owner: "Self", min: 1 },
  "give-confuse-target-1-HA": { types: ["Creature"], owner: "None", min: 1 },
  "give-cruse-target-sacrifice-5-discard-2-hand-random": { types: ["Creature"], owner: "None", min: 1 },
  "give-debuff-hex-half-hp-target": { types: ["Creature"], owner: "Opponent", min: 1 },
  "give-immortal-one-hit-immediately": { types: ["Creature"], owner: "Self", min: 1 },
  "give-immortal-target-1-turn": { types: ["Creature"], owner: "Self", min: 1 },
  "give-mark-debuff-1-damage": { types: ["Creature"], owner: "Opponent", min: 1 },
  "give-parry-1-target": { types: ["Creature"], owner: "Self", min: 1 },
  "give-reflect": { types: ["Hero", "Creature"], owner: "Self", min: 1 },
  "give-silence-1-target": { types: ["Creature"], owner: "None", min: 1 },
  "give-silence-and-confuse-target-1": { types: ["Creature"], owner: "Opponent", min: 1 },
  "give-silence-card-2-taget-HA": { types: ["Creature"], owner: "Opponent", min: 1 },
  "give-stasis-1-turn-target": { types: ["Creature"], owner: "None", min: 1 },
  "give-stoneskin-target": { types: ["Creature"], owner: "Self", min: 1 },
  "heal-3-target-HA": { types: ["Creature"], owner: "Self", min: 1 },
  "heal-max-target": { types: ["Creature"], owner: "Self", min: 1 },
  "heal-target-3": { types: ["Hero", "Creature"], owner: "Self", min: 1 },
  "hero-power-asclepius-restorative-touch": { types: ["Hero", "Creature"], owner: "Self", min: 1 },
  "hero-power-atalanta-battle-harden": { types: ["Creature"], owner: "None", min: 1 },
  "reveal-sleeping-target": { types: ["Creature"], owner: "None", min: 1 },
  "set-hp-1-HA": { types: ["Creature"], owner: "Opponent", min: 1 },
  "stun-target-HA": { types: ["Creature"], owner: "Opponent", min: 1 },
  "swapStats-target-HA": { types: ["Creature"], owner: "None", min: 1 },
  "system-GenericAttack": { types: ["None"], owner: "Opponent", min: 1 },
  "warden-rooted-restoration": { types: ["Hero", "Creature"], owner: "Self", min: 1 },
});


/**
 * What a keyword is CALLED and what it MEANS, from the served database's own `keywords[]`.
 *
 * ⛔ The titles are the GAME's, not ours. A card wearing a condition the player cannot name
 * is a rule they cannot discuss, search or learn - see `revival-mechanics`, the three
 * questions every mechanic has to answer before it counts as shipped.
 */
export interface KeywordInfo {
  readonly title: string;
  readonly text: string;
}

export const KEYWORD_INFO: Readonly<Record<string, KeywordInfo>> = Object.freeze({
  "Achilles": { title: "Cole Ironside", text: "As long as you control another Republic card Cole Ironside, Champion of the Republic is immune" },
  "AchillesAura": { title: "Champion's Aegis", text: "While Cole Ironside, Champion of the Republic is in play and you control another Republic card, he cannot be harmed." },
  "Alpha": { title: "Summon", text: "Summon a Timber Timber Timber Wolf Pup." },
  "AlphaWolfAttackAura": { title: "Pack Alpha", text: "Friendly Wolves have +{value} attack." },
  "AppliedSleepingCreatures": { title: "Apply Sleeping", text: "All Creatures with lava cost 4 or more gain sleep at the start of each turn." },
  "Armor": { title: "Armor", text: "Adds {value} armour to your hero, each stack of armour absorbs 1 point of damage and is then removed." },
  "AsclepiusHeroPower": { title: "Restorative Touch", text: "Hero power: restore {value} Health." },
  "Aspirant": { title: "Aspirant", text: "Gains +1/+1 whenever a creature with higher attack enters the battlefield" },
  "AtalantaHeroPower": { title: "Battle Harden", text: "Hero power: deal {value} damage to a unit. If it is friendly, also give it +1/+1." },
  "AttackAuraGain": { title: "Weight of the Hollow", text: "While this is in play, the listed creatures have their Attack changed, to a minimum of 1." },
  "AuraQueenXanthe": { title: "Aura", text: "While Rowan, Queen of the Range is in play, Other Wilno Kin you control have +1/+1" },
  "Barricade": { title: "Barricade", text: "This cannot attack. It stands and holds the line." },
  "Barricade ": { title: "Barricade ", text: "Barricade upon death this card blocks a spot on your side of the board." },
  "BattleHarden": { title: "Battle Harden", text: "Deal {value} damage to a unit. If it is friendly, also give it +1/+1." },
  "Blacksmith": { title: "Master Smith", text: "When placed on board, increases the damage of the targeted minion to the highest on board." },
  "Buff": { title: "Buff", text: "Can buff other cards." },
  "Buff-0-2-AOE_HA": { title: "Buff", text: "Give +0/+2 to all creatures you control" },
  "BuffArmor": { title: "Armour Up", text: "Gain {value} Armour. Each stack absorbs 1 point of damage and is then spent." },
  "BuffAttack": { title: "Strengthen", text: "Permanently gain {value} Attack." },
  "BuffAttackForeachHandCard": { title: "Buff Attack", text: "Has +1/+0 for each card in hand" },
  "BuffHealth": { title: "Fortify", text: "Permanently gain {value} Health." },
  "BuffHealthForeachHandCard": { title: "Buff Health", text: "Has +0/+1 for each card in hand" },
  "BuffReplaceAttack": { title: "Attack Until", text: "Gain {value} Attack. The change lasts only as long as the effect that granted it." },
  "BuffReplaceAttackLimit": { title: "Blunt", text: "Attack changes by {value}, and never falls below the effect's floor." },
  "BuffReplaceHealth": { title: "Health Until", text: "Health changes by {value}. The change lasts only as long as the effect that granted it." },
  "BuffReplaceMana": { title: "Cheapen", text: "The card's Foxfire cost changes by {value} while the effect lasts." },
  "BuffedArmor": { title: "Buffed Armor", text: "Buffed armor {value}." },
  "BuffedAttack": { title: "Buffed Attack", text: "Buffed attack {value}." },
  "BuffedAttackAura": { title: "Buff Attack Aura", text: "Has attack {value} for each Wilno Kin card in your graveyard" },
  "BuffedAttackTemp": { title: "Buffed Attack", text: "Buffed attack {value} for moves {length}" },
  "BuffedHealth": { title: "Buffed Health", text: "Buffed health {value}." },
  "CaladonianDeathblow": { title: "Deathblow", text: "Summons one or more cards. The summoning will fail if you have 7 cards on board already." },
  "Charon": { title: "Summon", text: "Summon 1 Jasper the Restless. If you have more than 5 cards in your graveyard summon 2" },
  "ChironAttackAura": { title: "Herd Strength", text: "Gains Attack for each allied creature of its kind on the battlefield." },
  "ConditionEffect": { title: "Conditional", text: "This does one thing or another, decided when it resolves. The card text says which condition." },
  "ConfusedTargetHA": { title: "Confused", text: "Gives confusion to the chosen target." },
  "Confused_one": { title: "Confused", text: "Attacks a random minion on board after attacking your target." },
  "Confusing": { title: "Confused", text: "Its attacks strike a random target instead of the one you choose." },
  "Copy": { title: "Copy", text: "Get a copy of this card back to your hand after playing it." },
  "Curse": { title: "Curse", text: "Upon dealing damage, reduce your target's damage by half." },
  "DamageAllCards_HA": { title: "Damage All Cards", text: "ACTIVE. Once per combat, deal {value} damage to all cards on board." },
  "DamageAllOpponentCards_HA": { title: "Damage All Cards", text: "ACTIVE. Once per combat, deal {value} damage to all opponent cards on board." },
  "DamageTargetCard_HA": { title: "Damage Target Card", text: "ACTIVE. Once per battle, deal {value} damage to the selected enemy card." },
  "DeBuffHealth": { title: "Sap", text: "Health is reduced. A negative percentage takes that share of its current Health." },
  "DealDamage": { title: "Damage", text: "Deal {value} damage." },
  "DealDamageX": { title: "Damage X", text: "Deal damage equal to a value the board decides when it resolves." },
  "DealDamage_AllNonSagittarian": { title: "Deal Damage", text: "Deal {value} damage to all non Sagittarian cards." },
  "DealDamage_RandomCard": { title: "Deal Damage", text: "Deal {value} damage to a random enemy card." },
  "DebuffedAttack": { title: "Debuffed Attack", text: "Debuffed attack {value}." },
  "DebuffedHealth": { title: "Debuffed Health", text: "Debuffed health {value}." },
  "DebuffedHealthPercent": { title: "Debuffed Health", text: "Debuffed heatlh {valuePercent}." },
  "DeckDepleted": { title: "Fatigue", text: "Your deck is empty. Drawing now costs you {value} Health, and the toll grows." },
  "Destroy": { title: "Destroy", text: "The target is destroyed outright, whatever its Health." },
  "DestroyCard_HA": { title: "Destroy", text: "ACTIVE. Deal massive damage to an enemy card." },
  "DevourLostSouls": { title: "Devour Lost Souls", text: "Whenever a unit dies, place a Soul counter on Lantern Fox. At {value} Soul counters restore 2 Health and draw a card, then remove the counters." },
  "Disarm_HA": { title: "Disarm", text: "ACTIVE. Once per combat, set one enemy card\u2019s damage to 0." },
  "Discard": { title: "Discard", text: "Discard {value} card(s) from hand." },
  "DiscardDeck": { title: "Mill", text: "The top card(s) of the deck go straight to the graveyard." },
  "DiscardTurnOwnerRessurect": { title: "Discard", text: "At the beginning of your turn you may discard a Card, return target card from graveyard to your hand." },
  "DiscardX": { title: "Discard X", text: "Discard a number of cards the board decides when it resolves." },
  "Draw": { title: "Draw", text: "Add {value} cards from your active deck to your hand." },
  "DrawAoe": { title: "Fetch", text: "Draw a matching card from your deck, then shuffle." },
  "DrawCard": { title: "Draw", text: "Draw a card from your deck into your hand." },
  "DrawEachTurn": { title: "Draw", text: "At the end of their turn each hero draw a card" },
  "DrawIfPlayedCard": { title: "Draw If Played", text: "Draw a card, but only if the named kind of card has already been played." },
  "DrawXCard": { title: "Draw X", text: "Draw a number of cards the board decides when it resolves." },
  "DryadsCurse": { title: "Dryad's Curse", text: "The first enemy unit that attacks your Hero each turn loses 2 attack until your next turn (minimum 1)." },
  "Empower": { title: "Empower", text: "Your Hero gains +{value} attack for 3 turns" },
  "EvilEye_HA": { title: "Hex", text: "ACTIVE. Once per combat, set one enemy card\u2019s health to 1." },
  "ExtraCard": { title: "Token Copy", text: "Adds a copy of the card to your hand. The copy has no Rally and costs nothing." },
  "ExtraCard_Ares": { title: "Summon", text: "Add one Iron Company Soldier to  your hand" },
  "ExtraCard_ShadeWarrior": { title: "Summon", text: "Add one Cragborn Goat to  your hand" },
  "ExtraHealth_HA": { title: "Extra Health", text: "PASSIVE. Get +5 health." },
  "FadeHealth": { title: "Fade", text: "At the end of your turn this creature suffers {value} damage" },
  "Fast": { title: "Fast", text: "Enables the card to attack enemies on the same turn that it is summoned." },
  "Fly": { title: "Fly", text: "This unit ignores Taunt effects" },
  "Fortify": { title: "Fortify", text: "Increases its health each turn by 1." },
  "FortifyArcadia": { title: "Fortify", text: "All The_Verdant_Hollow cards have fortified while this card is in play." },
  "Frenzy": { title: "Frenzy", text: "Attacks with immunity {value} against random opponent's creatures on the board after attacking your target." },
  "FromBeyondTheGrave": { title: "From Beyond the Grave", text: "After drawing cards, return a random Wolf or Undead Wolf from your graveyard to your hand. It costs 2 additional Lava." },
  "GenericAttack": { title: "Attack", text: "This minion can attack." },
  "GiveEffects": { title: "Grant", text: "Hands another effect to its target. What is granted is named on the card." },
  "GiveTemporaryEffects": { title: "Grant Until", text: "Grants an effect that lasts only while this card is in play." },
  "GiveTemporaryEffectsOnce": { title: "Grant Once", text: "Grants an effect a single time, then stops." },
  "Give_ImmuneToPoison": { title: "Give Immunity", text: "Your units and hero are immune to poison" },
  "Grant_Immune": { title: "Immune", text: "Grant friendly card Immune" },
  "Growth": { title: "Growth", text: "Reduces the Foxfire cost of a card in your hand." },
  "GrowthAttack": { title: "Growth ", text: "When this creature is healed gain +{value}/+0" },
  "HandCountBuff": { title: "Deep Pockets", text: "Your hand can hold {value} more card(s)." },
  "Hand\u0421apacity": { title: "Hand Capacity", text: "Increase your hand size by +1" },
  "Heal": { title: "Heal", text: "Restores {value} health points." },
  "Heal-HA": { title: "Heal", text: "Restores {value} health points to hero." },
  "HealAdjacentPercent": { title: "Heal", text: "Restores {valuePercent} health points to adjacent creatures." },
  "HealPercent": { title: "Heal", text: "Restores {valuePercent} health points." },
  "HealRally": { title: "Rally", text: "Restore 3HP to target" },
  "HealTarget": { title: "Heal", text: "Restores {value} health points to target." },
  "HealTargetPercent": { title: "Heal", text: "Restores {valuePercent} health points to target." },
  "Hex": { title: "Hex", text: "Reduce the health of the targeted enemy card by half." },
  "Hex_HA": { title: "Hex", text: "ACTIVE. Once per combat, reduce the health of the targeted enemy card by {valuePercent}." },
  "IgnoreTaunting": { title: "Ignore Taunting", text: "Ignore taunt when affected by Stealth. Gain Stealth at the beginning of your turn" },
  "IllusionClarity": { title: "Illusion: Clarity", text: "Silences a random enemy unit costing 3 or less when the illusion appears." },
  "IllusionClarityRally": { title: "Clarity", text: "Rally: reveals what is hidden, stripping Stealth from the target." },
  "IllusionDust": { title: "Illusion: Dust", text: "Gives a random friendly unit Stealth until your next turn when the illusion appears." },
  "IllusionDustRally": { title: "Illusion Dust", text: "Rally: give a random friendly unit Stealth until your next turn." },
  "IllusionFlame": { title: "Illusion: Flame", text: "Deals 1 damage to a random enemy when the illusion appears." },
  "IllusionWind": { title: "Illusion: Wind", text: "Gives a random friendly unit +1 Attack and Fast when the illusion appears." },
  "IllusionWindRally": { title: "Illusion Wind", text: "Rally: give a random friendly unit +1 Attack and Fast." },
  "Immortal": { title: "Immortal", text: "While this card is on board, your hero can't take damage." },
  "ImmortalAura": { title: "Undying Aura", text: "While this is in play, your hero cannot be killed." },
  "ImmortalOneHit": { title: "Immune until hit", text: "Ignores the next damage that would be dealt to it. Once it is hit, the protection is gone." },
  "Immune": { title: "Immune", text: "Prevents damage dealt from any source to the target, and prevents all enemy interaction with the target." },
  "ImmuneToKeyword": { title: "Immune", text: "Cannot be affected by the named keyword at all." },
  "ImmuneToPoisonAura": { title: "Clean Blood", text: "While this is in play, your units and hero are immune to poison." },
  "ImmuneToSleepAura": { title: "Restless", text: "While this is in play, the listed creatures cannot be put to sleep." },
  "ImmunitingToSleep": { title: "Immune", text: "Prevents sleeping" },
  "Kallisto": { title: "Buff Health", text: "Give {value} health points to all beasts you control." },
  "KallistoAura": { title: "Den Mother", text: "Other Beasts you control have +0/+2 while this is in play." },
  "KallistoForestDealHeroDamage": { title: "Deal Damage", text: "Whenever you summon a Beast deal 1 damage to enemy hero" },
  "KaustikaPoison": { title: "Revenge", text: "Upon death, poisons all creatures on the table." },
  "KobaloiRecruiterAura": { title: "Gremlin Recruiter", text: "While Sinkhole Gremlin Recruiter is in play, Sinkhole Gremlins cost 1 less Foxfire." },
  "Kopis": { title: "Summon", text: "Summon 1 rip and rend, if less than 20HP summon 2" },
  "LavaCostAura": { title: "Lava Cost Aura", text: "While is in play, Kobaloi cost {value} less to play" },
  "LavaCostAuraBeasts": { title: "Rally", text: "While is in play, Beasts cost {value} less to play" },
  "LifeSteal": { title: "LifeSteal", text: "Whenever this card deals damage it also restores that much health." },
  "ManaGain": { title: "Refill", text: "Refill {value} Foxfire this turn." },
  "ManaGainOverflow": { title: "Overflow", text: "Gain {value} Foxfire, even past your usual limit." },
  "Mark": { title: "Mark", text: "Any direct attack against this creature gains {value} dmg" },
  "MasterOfMischief": { title: "Master of Mischief", text: "Once per turn, when one of your units damages the enemy Hero and they have more than 5 cards in hand, that player discards a random card." },
  "MedeaHeroPower": { title: "Veil of Illusions", text: "Hero power: hide a friendly unit behind the veil." },
  "Mulligan": { title: "Mulligan", text: "The opening swap. Throw back any cards you would rather not keep, once, before the first turn." },
  "MyrmidonRecruit": { title: "Mesa Legion Recruit", text: "Give +1/+1 as long as you control another Myrmidon" },
  "MyrmidonTrainer": { title: "Aura", text: "Other Myrmidon creature under your control have +1/+1 while Mesa Legion Drillmaster is in play" },
  "MyrmidonTrainerAttackAura": { title: "Drillmaster's Edge", text: "Other Republic creatures have +1 Attack while Mesa Legion Drillmaster is in play." },
  "MyrmidonTrainerHpAura": { title: "Drillmaster's Guard", text: "Other Republic creatures have +1 Health while Mesa Legion Drillmaster is in play." },
  "Nemean": { title: "Deal Damage", text: "Deal 3 damage to target creature, or 5 damage after turn 4" },
  "Overcharge": { title: "Overcharge", text: "Spend Foxfire beyond the card's cost, and the effect grows with what you spend." },
  "OverrideStat": { title: "Set Stat", text: "Sets a stat to an exact number, ignoring whatever it was." },
  "Parry": { title: "Parry", text: "When this creature attacks, reduce defending creature's stats by {value}/-0. A creatures Attack cannot go below 0. This effect triggers before combat" },
  "PheareiDebuffAttackerGate": { title: "Thorned Hide", text: "Whatever attacks this comes away weaker." },
  "Pillager": { title: "Buff Attack", text: "Whenever you summon or play a Creature, gains +1/+0" },
  "Poison": { title: "Poison", text: "Poison deals damage to the target after the turn is over. Cumulatively stacking debuff." },
  "PoisonEnemies_HA": { title: "Poison", text: "ACTIVE. Poison all enemy cards and hero on board." },
  "Poison_HA": { title: "Poison", text: "ACTIVE. Once per combat,2 poison your opponent." },
  "Poison_Immunity": { title: "Poison Immunity", text: "Prevents poisoning." },
  "Poisoning": { title: "Poisoning", text: "Poison deals damage to the target after the turn is over. Cumulatively stacking debuff." },
  "PowerOfGod": { title: "Power Of God", text: "An extremely rare and powerful card. Only one copy of this card can be in a deck." },
  "QueenOfTalons": { title: "Queen of Talons", text: "At the start of your turn, deal {value} damage to a random damaged enemy unit." },
  "Rage": { title: "Rage", text: "Increases its damage each turn by 1." },
  "RallyChironTutorLegends": { title: "Rally", text: "Draw a card for Each centaur on the battlefield" },
  "RallyDiscardByCardsInTable": { title: "Rally", text: "Opponent discards the top X cards of their deck. Where X is the number of Kobaloi in play" },
  "RallyKallistoForest": { title: "Rally", text: "While Kallisto is in play other Beast you control have +0/+2" },
  "RallyNextTaunt": { title: "Rally", text: "The next Beast card gains Taunt" },
  "Raving": { title: "Raving", text: "Whenever The Raving Ones kill an enemy creature, restore +{value} Health to your hero" },
  "Reborn": { title: "Reborn", text: "Once per combat, it can attempt to return from the dead." },
  "Reborning": { title: "Reborn", text: "The first time this dies, it returns to the battlefield with 1 Health." },
  "Recon": { title: "Recon", text: "When this attacks a hero, draw a card." },
  "ReconHero": { title: "Recon", text: "When an enemy hero is attacked, the attacking player draws 1 card." },
  "Reflect": { title: "Reflect", text: "Reflect all damage taken back at the attacker for 2 turns." },
  "Regen": { title: "Regenerate", text: "Restores {value} Health when its condition is met." },
  "Resurrect": { title: "Resurrect", text: "Resurrect {value} random creature from Graveyard." },
  "Resurrect-HA": { title: "Resurrect", text: "ACTIVE. Resurrect 1 random creature from Graveyard. If you have more than 5 cards in your graveyard resurrect 2." },
  "ResurrectX": { title: "Resurrect X", text: "Return creatures from your graveyard to the battlefield. The board decides how many." },
  "Reveal": { title: "Reveal", text: "Strips a hidden state, showing the card for what it is." },
  "RevealSleepingBests": { title: "Reveal", text: "Beasts with lava cost 2 or less are immune to sleep." },
  "RevealSleepingCreatures": { title: "Reveal", text: "Creatures with lava cost 3 or less are immune to sleep." },
  "RevealStealthAOE": { title: "Reveal", text: "Reveals all enemy stealth cards" },
  "Revenge": { title: "Revenge", text: "When this card dies it destroys its attacker" },
  "RevengeAmazons": { title: "Revenge", text: "Triggers the abilities of all Wilno Kin creatures you control when that creature dies." },
  "RevengeDiscardHand": { title: "Revenge", text: "Discard random {value} cards from hand." },
  "RevengeQueenXanthe": { title: "Revenge", text: "Triggers the abilities of all Wilno Kin creatures you control after its death." },
  "RevengeSacrifice": { title: "Revenge", text: "Lose {value} health points." },
  "Sanctification": { title: "Sanctification", text: "Whilst is in play, the Fast effect does not trigger." },
  "Silence": { title: "Silence", text: "Remove any buffs and special abilities from an enemy card." },
  "Silence-2-Target-HA": { title: "Silence", text: "ACTIVE. Once per combat, silence 2 selected enemy card." },
  "SilenceAllCreatures": { title: "Silence", text: "Silence all creatures." },
  "SilenceHero_HA": { title: "Silence Hero", text: "PASSIVE. When game start, silence the enemy hero indefinitely." },
  "SilverWarrior": { title: "Summon", text: "Summon 2 arctus bears, if less than 25HP summon 3" },
  "SisyphusHeroPower": { title: "Unholy Pact", text: "Hero power: pay in blood for what you take." },
  "Slash": { title: "Slash", text: "While attacking, deals damage to all enemy cards on board" },
  "SleepAll_HA": { title: "Sleep", text: "Put all creatures to sleep for {value} turn" },
  "Sleeping": { title: "Sleeping", text: "A sleeping card cannot attack until the sleep effect wears off." },
  "SpellDamage_HA": { title: "Spell Damage", text: "ACTIVE. Once per combat, deal 1 damage to any target while ignoring taunts." },
  "Stasis": { title: "Exile", text: "This creature cannot attack or take damage for 1 turn" },
  "Stealthing": { title: "Stealth", text: "Stealth: This creature cannot be targeted until it attacks" },
  "Stike": { title: "Battlefury", text: "Deals damage to your target twice, second attack with immunity." },
  "StoneSkin": { title: "Stone Skin", text: "Stuns its attackers while defending." },
  "StrikeConfused": { title: "Battlefury Confused", text: "Attacks with immunity {value} against random opponent's creatures on the board after attacking your target." },
  "Striking": { title: "Battlefury", text: "Strikes the target for {value} on the way in, before regular damage." },
  "Stun": { title: "Stun", text: "Can stun others." },
  "Stun-2-Random-HA": { title: "Stun", text: "ACTIVE. Once per combat, stun random 2 enemy card." },
  "StunRandom": { title: "Stun", text: "Stun a random enemy minion." },
  "Stun_HA": { title: "Stun", text: "ACTIVE. Once per combat, stun one enemy card" },
  "Stunning": { title: "Stunning", text: "Stunned cannot make moves." },
  "SuffleDeck": { title: "Shuffle", text: "Shuffles your deck." },
  "Summon": { title: "Summon", text: "Summons one or more cards. The summoning will fail if you have 7 cards on board already." },
  "Summon-2-arctusBears_HA": { title: "Summon Arctus Bears", text: "ACTIVE. Summon {value} arctus bears" },
  "Summon-3-arctusBears_HA": { title: "Summon Arctus Bears", text: "ACTIVE. Summon {value} arctus bears" },
  "SummonBlacksmith_HA": { title: "Summon Master Smith", text: "ACTIVE. Once per combat, summon 1/3 Master Smith on board. Master Smith gain +X/+0 where X is the highest attack value on the board" },
  "SummonRipAndRend_HA": { title: "Summon Stormrunner", text: "ACTIVE. Summon {value} rip and rend, if less than 20HP summon 2" },
  "SummonSparoiPeltast_HA": { title: "Summon Bonefield Skirmisher", text: "ACTIVE. Summon {value} spartoi peltast" },
  "SwapStats": { title: "Switch", text: "ACTIVE. Once per battle, swap the damage and health of the selected card on the table." },
  "SynaPoisonedAttackerDebuff": { title: "Venom Coat", text: "A creature that attacks this is weakened by {value} Attack." },
  "TalosAura": { title: "Forge Discount", text: "Foxfire cost decreases by 1 for each Foundryman card in play." },
  "Taunt": { title: "Taunt", text: "Enemies must attack cards with taunt before any non-taunt characters." },
  "TauntAdjacent": { title: "Rally", text: "Adjacent creatures gain taunt" },
  "Taunting": { title: "Taunt", text: "Enemies must attack this before they can attack anything else you control." },
  "ThresholdCounter": { title: "Soul Count", text: "Counts up. When it reaches {value}, the card's payoff fires." },
  "Tomyios": { title: "Sacrificial Buff", text: "ACTIVE. Once per battle, give a card +2 /-1" },
  "TomyiosDiscardGate": { title: "Mudgrin's Toll", text: "Attacking with this costs you a card from hand." },
  "ToxicHarvest": { title: "Toxic Harvest", text: "Whenever a Poisoned enemy dies, restore {value} Health to your Hero." },
  "Undead": { title: "Undead", text: "A creature type, not an ability on its own. Some cards seek out, count or reward Undead creatures." },
  "Undefeatable_HA": { title: "Undefeatable", text: "ACTIVE. Once per combat, your hero gains immune for one turn." },
  "Vendetta": { title: "Vendetta", text: "Whenever this Creature takes damage it gains +{value}/+0" },
  "VenomOfDelight": { title: "Venom of Delight", text: "A poisoned enemy that attacks loses 1 attack for that combat, to a minimum of 1." },
  "VenomtailPoisonDeathHeal": { title: "Venomtail's Feast", text: "Whenever a poisoned creature dies, your hero is healed." },
  "WardenEmeraldElk": { title: "Elk's Vigil", text: "Rally: if your hero was healed this turn, draw a card." },
  "WardenHeroHealedThisTurn": { title: "Tended", text: "Marks that your hero has been healed this turn. Other cards look for it." },
  "WardenRootedRestoration": { title: "Rooted Restoration", text: "Restore {value} Health. If the target is then at full Health, it also gains +2 Health permanently." },
  "Wolfshadow": { title: "Damage Random Card", text: "ACTIVE. Once per combat, deal 1 damage to a random enemy card" },
  "WolfshadowGraveyardReturn": { title: "Wolfshadow's Return", text: "Calls a card back out of the graveyard." },
});
